export default __webpack_public_path__ + "static/article-saving-for-financial-freedom-7d375f763bc98a3b70d9c2d107bf16b3.jpg";